import {Trans, useTranslation} from "ni18n";
import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {useV5ImgSrc} from "src/useV5ImgSrc";

const QuestionAnswers: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();

  const answers = [
    i18n.t("Helpful"),
    i18n.t("Reassuring"),
    i18n.t("Smooth"),
    i18n.t("Attentive"),
    i18n.t("Convenient"),
    i18n.t("Efficient"),
    i18n.t("Excellent"),
    i18n.t("Simple"),
  ];
  return (
    <div>
      <div className="df fdc-sm pos-r">
        <div className="fx3 df fdc jcc aife aifs-sm pl8 pr20 pv15 pb6-xs ph4-xs">
          <div className="df fdc maxw42">
            <span className="ttu font-ir gray400 font-im fs13 mb8 mb6-xs font-mb-f-xs fs12-xs">
              {i18n.t("We asked")}
            </span>
            <h2 className="fs48 lh12 fs40-lg fs38-md fs30-sm fs24-xs maxw32-lg">
              <Trans>
                What's one word you would use to{" "}
                <span className="purple">describe your experience in the care program?</span>
              </Trans>
            </h2>
          </div>
        </div>

        <div className="fx2 df fdc bg-lighterPurple pl12 pl8-md ph4-xs pt12 pb10">
          <span className="ttu font-ir gray400 font-im fs13 mb8 mb6-xs font-mb-f-xs fs12-xs">
            {i18n.t("You Answered")}
          </span>
          {answers.map(a => (
            <span key={a} className="darkPurple fs60 fs48-lg fs40-md fs38-sm font-csb mb4 mb3-xs">
              {a}
            </span>
          ))}
        </div>

        <LazyLoadImage
          className="pos-a maxw6 maxw5-md dn-sm"
          style={{left: "57%", top: 90}}
          src={useV5ImgSrc("illustrated-arrow-purple")}
        />
      </div>
    </div>
  );
};

export default QuestionAnswers;
